<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of curBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="clickHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>
<script>
  export default {
    name: 'DetailFooterButtons',
    props: {
      status: {
        type: String,
        default: '',
      },
      billStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        allBtnList: [
          {
            title: '编辑',
            type: 'primary',
            clickName: 'edit',
            params: 1,
            key: 'edit',
          },
          {
            title: '查看',
            type: 'primary',
            clickName: 'view',
            params: 1,
            key: 'view',
          },
          {
            title: '提交',
            type: 'primary',
            clickName: 'submit',
            params: 1,
            key: 'submit',
          },
          {
            title: '保存',
            type: 'primary',
            clickName: 'save',
            params: 1,
            key: 'save',
          },
          {
            title: '通过',
            type: 'primary',
            clickName: 'pass',
            params: 1,
            key: 'pass',
          },
          {
            title: '驳回',
            type: 'danger',
            clickName: 'refuse',
            params: 1,
            key: 'refuse',
          },
          {
            title: '取消',
            type: 'primary',
            clickName: 'cancel',
            params: 1,
            key: 'cancel',
          },
          {
            title: '保存抽检',
            type: 'primary',
            clickName: 'saveCheck',
            params: 1,
            key: 'saveCheck',
          },
        ],
        curBtnList: [],
        isShowFooterBtnPanel: true,
      };
    },
    methods: {
      // 动态派发事件上去
      clickHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      buttonStatusChange(status, billStatus) {
        this.curBtnList = this.allBtnList.map((item) => {
          if (status == 'detail') {
            //详情页面按钮
            if (billStatus == '10') {
              if (['cancel'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else if (billStatus == '04') {
              if (['cancel', 'saveCheck'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            } else {
              if (['view', 'edit', 'save', 'cancel', 'saveCheck'].includes(item.key)) {
                return item;
              } else {
                return {
                  ...item,
                  disabled: true,
                };
              }
            }
          } else if (status == 'create') {
            if (['edit', 'save', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (status == 'approval') {
            if (['pass', 'refuse'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (status == 'edit') {
            if (['submit', 'save', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = true;
      },
    },
    watch: {
      status: {
        handler(val) {
          this.buttonStatusChange(val, this.billStatus);
        },
        immediate: true,
      },
      billStatus: {
        handler(val) {
          this.buttonStatusChange(this.status, val);
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
